import React from 'react';

export default function TravelBookingHero() {
  return (
    <div className="min-h-screen bg-[#f5f0e8] flex items-center justify-center p-4">
      <div className="w-full max-w-7xl">
        {/* Main Container */}
        <div className="relative">
          {/* Background Image with Custom Shape */}
          <div className="relative w-full h-[500px]">
            {/* Image */}
            <img
              src="https://img.freepik.com/free-photo/architecture-ancient-monument-world-heritage-day-celebration_23-2151297157.jpg?semt=ais_hybrid&w=740&q=80"
              alt="Charminar Hyderabad"
              className="w-full h-full object-cover"
              style={{
                clipPath: 'polygon(0 0, 100% 0, 100% 75%, 75% 75%, 65% 100%, 50% 85%, 35% 100%, 25% 75%, 0 75%)'
              }}
            />
            
            {/* White Speech Bubble Overlay */}
            <div className="absolute top-8 left-1/2 -translate-x-1/2 bg-white rounded-3xl shadow-lg px-12 py-8 max-w-4xl">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 text-center leading-tight">
                "Fast, secure, and hassle free<br />
                travel bookings to<br />
                destinations near and far."
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}